var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-app-cop"},[_c('micro-app',{attrs:{"name":"app-cop","url":_vm.config.microCopUrl,"data":_vm.storeInfo,"iframe":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }